import { useEffect } from "react";
import Lenis from "lenis";

// Desplazamiento suave compartido. Se desactiva con prefers-reduced-motion.
export function useScrollSuave(desactivado) {
  useEffect(() => {
    if (desactivado) return undefined;
    const lenis = new Lenis({ duration: 1.15, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, [desactivado]);
}
